
import { Button, Dropdown, Input, Select, Space, TableProps } from "antd";
import ActionIcon from "../../../assets/icons/ActionIcon";
import SearchIcon from "../../../assets/icons/SearchIcon";
import ViewIcon from "../../../assets/icons/ViewIcon";
import TitleBar from "../../../components/common/TitleBar";
import CustomTable from "../../../components/ui/CustomTable";
import { useGetWaitingApprovalInvoiceListQuery } from "../../../features/Invoice/invoice.api";
import { InvoiceListDetails } from "../../../features/Invoice/invoice.type";
import { useGetVendorListQuery } from "../../../features/Vendor/vendor.api";
import useModal from "../../../hooks/useModal";
import useTable from "../../../hooks/useTable";
import SidebarLayout from "../../../layouts/SidebarLayout";
import {
  addCommaInNumber,
  countParPageSerialNumber,
} from "../../../utils/number";
import { capitalize, valueOrNa } from "../../../utils/string";
import {
  addKeyInArray,
  selectArrayOption,
  selectSearchOption,
} from "../../../utils/utils";
import InvoiceDetails from "./InvoiceDetails";
import { INVOICE_STATUS_CONFIG } from "./InvoiceList";

type TFilter = {
  vendor_id?: string;
  status?: string;
};

type TModalData = { id: number; title: string };

const WaitingForApprovalList = () => {
  const { open, handleOpen, handleClose } = useModal<TModalData, "ARCHIVE">();

  const {
    page,
    limit,
    filter,
    keyword,
    handleFilter,
    handleLimit,
    handlePagination,
    handleSearch,
  } = useTable<TFilter>({});

  const {
    data: invoiceList,
    isLoading,
    isFetching,
  } = useGetWaitingApprovalInvoiceListQuery({
    params: {
      ...filter,
      page,
      limit,
      search: keyword,
    },
  });
  const { data: vendorList } = useGetVendorListQuery({
    params: { status: "active" },
  });

  const columns: TableProps<InvoiceListDetails>["columns"] = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => countParPageSerialNumber(page, limit, index),
    },
    {
      title: "Invoice Id",
      dataIndex: "invoice_id",
      render: (val) => valueOrNa(val),
    },
    {
      title: "Job Title",
      dataIndex: "job_title",
      render: (val) => valueOrNa(val),
    },
    {
      title: "Vendor",
      dataIndex: "vendor",
      render: (val) => valueOrNa(val?.business_name),
    },
    {
      title: "Reference ID",
      dataIndex: "reference_id",
      render: (val) => valueOrNa(val),
    },
    {
      title: "Invoice Amount (BDT)",
      dataIndex: "invoice_amount",
      render: (val) => addCommaInNumber(val),
    },
    {
      title: "Approver Status",
      dataIndex: "status",
      align: "center",
      render: (val) => {
        return (
          <span
            className={
              INVOICE_STATUS_CONFIG[
                String(
                  val as string,
                ).toLowerCase() as keyof typeof INVOICE_STATUS_CONFIG
              ]
            }
          >
            {capitalize(val?.split("_").join(" "))}
          </span>
        );
      },
    },
    {
      title: "Action",
      align: "center",
      width: 130,
      render: (invoice) => (
        <Space align="center">
          <Dropdown
            menu={{
              items: [
                {
                  key: "Open",
                  label: (
                    <Space>
                      <ViewIcon />
                      <span>Open</span>
                    </Space>
                  ),
                  onClick: () =>
                    handleOpen({
                      type: "VIEW",
                      data: {
                        id: invoice.id,
                        title: `${invoice.invoice_id} ${invoice.name}`,
                      },
                    }),
                },
              ],
            }}
            placement="bottomRight"
            trigger={["click"]}
            overlayClassName="w-[120px]"
          >
            <Button className="size-8 p-0 border-none shadow-none">
              <ActionIcon />
            </Button>
          </Dropdown>
        </Space>
      ),
    },
  ];
  return (
    <SidebarLayout title="Payable Management">
      <TitleBar
        title="Waiting for approval"
        subTitle="Manage vendor payment invoice"
      />
      <CustomTable
        title={"Invoices List"}
        loading={isLoading || isFetching}
        limit={limit}
        page={page}
        columns={columns}
        total={invoiceList?.data.totalLength}
        dataSource={addKeyInArray(invoiceList?.data.invoices || [])}
        handleLimit={handleLimit}
        handlePagination={handlePagination}
        hideDifferentRowColor
        filterSection={
          <>
            <Input
              className="bg-input"
              suffix={<SearchIcon />}
              placeholder="Search name, id"
              style={{ minWidth: 170, maxWidth: 180 }}
              onChange={(val) => handleSearch(val)}
            />
            <Select
              allowClear
              showSearch
              placeholder="Vendors"
              filterOption={selectSearchOption}
              options={selectArrayOption(
                vendorList?.data?.vendors || [],
                "business_name",
                "id",
              )}
              className="min-w-[90px] bg-select"
              rootClassName="icon-gray"
              onChange={(val) => handleFilter("vendor_id", val)}
              popupMatchSelectWidth={150}
              placement="bottomRight"
            />
            {/* <Select
              allowClear
              placeholder="Status"
              options={[
                {
                  label: "Pending For Disbursement",
                  value: "pending_for_disbursement",
                },
              ]}
              placement="bottomRight"
              className="bg-select"
              rootClassName="icon-gray"
              onChange={(val) => handleFilter("status", val)}
              popupMatchSelectWidth={220}
            /> */}
          </>
        }
      />

      <InvoiceDetails
        open={open.open && open.type === "VIEW"}
        handleClose={handleClose}
        data={open.data?.id}
        type="waiting-for-approval"
      />
    </SidebarLayout>
  );
};

export default WaitingForApprovalList;
